import React, { Component } from "react";
import { successToastStyle, errorToastStyle } from "../../../../customToast";
import { toast } from "react-toastify";
// import { bindActionCreators } from "redux";
import {
  pmgAddMemberFormAction,
  pmgEditMemberFormAction,
  getPmgSortAction,
  getPmgInvestAction,
  pmgInvestSortOrderAction,
  pmgInvestSortOrderAction1,
  dpiitAddMemberFormAction,
  getDpiitSortAction,
  dpiitEditMemberFormAction,
  validatePMGTeamFlds
} from "../../../../actions/pmgTeam.action";
import {
  uploadFileAction,
  removeFileAction
} from "../../../../actions/common.action";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Files from "react-files";
import {
  Form,
  Spinner,
  InputGroup,
  Button,
  Image,
  Container
} from "react-bootstrap";
import {
  PHONE_VALIDATE_CMS,
  EMAIL_VALIDATE,
  DEFAULT_VALIDATION,
  PASSWORD_VALIDATE,
  VALIDATE_USER_ID,
  ADDRESS_VALIDATE,
  USER_EXIST,
  NAME_VALIDATE,
  CMS_NAME_VALIDATE,
  DESIGNATION_VALIDATE,
  LANDLINENUMBER_VALIDATE
} from "../../../../validation";
import PrivacyPolicy from "../../../footer/PrivacyPolicy";
// import { userSecurityKeyV2 } from "../../../actions/common.action";
import { JSEncrypt } from "jsencrypt/lib";
import { get, isArray } from "lodash";
import {
  ERROR_MSG,
  STATUS,
  FILE_FORMATS,
  IMAGE_FORMAT,
  FILE_SIZE_LIMIT
} from "../../../../constant";
import {
  isValidArray,
  setLocalstorage,
  searchByValueHelper,
  FormDataForImage,
  truncateData,
  truncateAddress
} from "../../../../helper";
import { bindActionCreators } from "redux";
import { ConfirmationComponent } from "../../../ConfirmationComponent";
import IconPlus from "../../../../assets/Files-icon.svg";
import cross_icon from "../../../../assets/cross-icon.svg";
import CancleIcon from "../../../../assets/CancelIcon.svg";
import ImageBackground from "../../../../assets/ImageBackground.svg";
import { event } from "jquery";
import { LoaderPage } from "../../../../component/Loader";
//import { pmgInvestSortOrderAction } from "../../../actions/pmgTeam.action";

export class CreateDpiitForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      pasted: false,
      designation: "",
      otherDesignation: "",
      designationError: false,
      otherDesignationError: false,
      designationMessage: "Please select Designation",
      otherDesignationMessage: "Please enter Designation",
      contactNumber: {},
      email: "",
      mobileNumber: "",
      address: "",
      contactType: "mobile",
      landlineNumber: "",
      defaultSelected: null,
      iigAccess: false,
      showOrganization: false,
      errors: {},
      active: false,
      isActive: (this.props.groupData && this.props.groupData.active) || false,
      isToggleOn: true,
      isProfiled: false,
      selectedImage: null,
      imageURL: null,
      image: null,
      files: [],
      count: 0,
      priority: 0,
      designationOptions: [],
      extension: null,
      isApiLoading: STATUS.LOADING,
      listResponce: [],
      dataUnsaved: false,
      allowPrompt: true
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getImageType();
    this.getDesignationData();
    this.setState({
      name: this.props.isEdit ? this.props.groupData.name : "",
      email: this.props.isEdit ? this.props.groupData.email : "",
      designation: this.props.isEdit ? this.props.groupData.designation : "",
      otherDesignation: "",
      address: this.props.isEdit ? this.props.groupData.address : "",
      image: this.props.isEdit ? this.props.groupData.image[0].id : [],
      mobileNumber: this.props.isEdit ? this.props.groupData.mobileNumber : "",
      landlineNumber: this.props.isEdit
        ? this.props.groupData.landlineNumber
        : "",
      active: this.props.isEdit ? this.props.groupData.active : "",
      count: this.props.isEdit ? this.props.groupData.image[0].id : "",
      selectedImage: this.props.isEdit
        ? this.props.groupData.image[0].mineType
        : ""
    });
    if (this.props.isEdit) {
      if (this.props.groupData.selectedContact == "L") {
        this.setState({ contactType: "landline" });
      } else {
        this.setState({ contactType: "mobile" });
      }
    }
  }

  syncEditDesignation = () => {
    const { isEdit, groupData } = this.props;
    const options = this.getDesignationOptions();

    // Run only once, only in edit mode, and only after options have loaded
    if (!isEdit || this.designationSynced || options.length === 0) return;
    this.designationSynced = true;

    var saved = groupData && groupData.designation ? groupData.designation : "";
    const isCustom =
      saved !== "" && !options.some(item => item.designationName === saved);

    this.setState({
      designation: isCustom ? "Other" : saved,
      otherDesignation: isCustom ? saved : ""
    });
  };

  // Point this at wherever designationOptions actually lives (state or props)
  getDesignationOptions = () => this.state.designationOptions || [];

  componentDidUpdate() {
    this.syncEditDesignation();
  }

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef =
      this.props.dpiitModelRef && this.props.dpiitModelRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      console.log(
        "Clicked outside the modal, but modal will not close.",
        dataUnsaved
      );
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          togglePopUp(event);
          return;
        }
      }
    }
  };

  onChange = (value, key) => {
    const { getGroupRolesForUser } = this.props;
    if (key === "groupId") {
      this.setState(
        {
          rolesList: [],
          dataUnsaved: true
        },
        async () => {
          const response = await getGroupRolesForUser(undefined, value);
          if (response) {
            const { data, status, message } = response;
            status
              ? toast.success(
                  <p className="toast-text-alignment">{message}</p>,
                  successToastStyle
                )
              : toast.error(
                  <p className="toast-text-alignment">{message}</p>,
                  errorToastStyle
                );
            if (isValidArray(data.data)) {
              this.setState({
                rolesList: data.data
              });
              this.getFilteredData({ sortData: data.data });
            } else {
              this.setState({
                rolesList: []
              });
            }
          }
        }
      );
    } else {
      this.setState(async prevState => {
        prevState[key] = prevState[key] || [];
        const indexId = prevState[key].indexOf(+value);
        indexId !== -1
          ? prevState[key].splice(indexId, 1)
          : prevState[key].push(+value);
        prevState[key] = [...prevState[key]];
        return {
          [key]: prevState[key],
          dataUnsaved: true
        };
      });
    }
  };

  handlefieldPaste = event => {
    this.setState({
      pasted: true,
      dataUnsaved: true
    });
  };

  handleChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const { name, value } = e.target;

    //name validation start
    let { errors } = this.state;
    let pasted = this.state.pasted;
    let nameInputValue = e.target.value;
    //end

    this.setState({ [name]: value, dataUnsaved: true });
    if (name === "landlineNumber") {
      const inputPhoneNumber = e.target.value.replace(/\D/g, "");
      let formattedPhoneNumber = "";
      for (let i = 0; i < inputPhoneNumber.length; i++) {
        if (i === 3 || i === 7) {
          formattedPhoneNumber += "-";
        }
        formattedPhoneNumber += inputPhoneNumber[i];
      }

      this.setState({ [name]: formattedPhoneNumber });
    } else if (name === "mobileNumber") {
      const inputPhoneNumber = e.target.value.replace(/\D/g, "");
      this.setState({ [name]: inputPhoneNumber });
    } else if (name === "name") {
      //console.log("*********name", name);
      let currentNameValue = this.state.name;
      let userName = this.state.name;

      if (pasted) {
        errors.name = CMS_NAME_VALIDATE(nameInputValue);
        userName = truncateData(nameInputValue);
        this.setState({
          name: userName
        });
      } else {
        errors.name = CMS_NAME_VALIDATE(value);
        if (currentNameValue.length < 30 && nameInputValue.length < 31) {
          this.setState({
            name: nameInputValue
          });
        } else if (nameInputValue.length >= 31) {
          // Stop typing further after 30 characters
          nameInputValue = currentNameValue;
          this.setState({
            name: nameInputValue
          });
        }
        this.validateField("name", e.target.value);
      }

      this.setState({
        pasted: false
      });
    } else if (name === "address") {
      let addressInputValue = e.target.value;
      let currentAddressValue = this.state.address;
      let truncatedAdd = this.state.address;

      if (pasted) {
        //console.log("pasted", pasted);
        errors.address = ADDRESS_VALIDATE(value);
        truncatedAdd = truncateAddress(addressInputValue);
        this.setState({
          address: truncatedAdd
        });
      } else {
        errors.address = ADDRESS_VALIDATE(value);
        if (currentAddressValue.length < 50 && addressInputValue.length < 51) {
          this.setState({
            address: addressInputValue
          });
        } else if (addressInputValue.length >= 51) {
          // Stop typing further after 30 characters
          addressInputValue = currentAddressValue;
          this.setState({
            address: addressInputValue
          });
        }
        this.validateField("address", e.target.value);
      }
      this.setState({
        pasted: false
      });
    }
  };

  onChangeMobile = e => {
    this.setState({
      contactType: "mobile",
      contactNumber: {},
      dataUnsaved: true
    });
    //this.setState({ contactNumber: {} });
  };
  onChangeLandline = e => {
    this.setState({
      contactType: "landline",
      contactNumber: {},
      dataUnsaved: true
    });
    //console.log(this.state.contactNumber, "onChangeMobile");
    //this.setState({ contactNumber: {} });
  };

  // handleChangeDesignation = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   const { name, value } = e.target;
  //   this.setState({ dataUnsaved: true });
  //   const updatedData = this.state.designationOptions.map((item) => {
  //     if (item.designationName == value) {
  //       this.setState({
  //         designation: item.designationName,
  //         designationError: false,
  //       });
  //       this.setState({ priority: item.priority });
  //     }
  //     return item;
  //   });

  // };

  handleChangeDesignation = e => {
    const { value } = e.target;

    const matched = this.state.designationOptions.find(
      item => item.designationName === value
    );

    this.setState({
      dataUnsaved: true,
      designation: value,
      priority: matched ? matched.priority : "",
      designationError: false,
      otherDesignationError: false
      // otherDesignation is intentionally left unchanged
    });
  };

  onError = (value, key) => {
    this.setState(prevState => {
      const error = isValidArray(prevState[key])
        ? { error: !prevState[key].length, message: ERROR_MSG.DEFAULT_MSG }
        : value;
      return {
        errors: {
          ...prevState.errors,
          [key]: error
        }
      };
    });
  };

  /**
   *  For upload files
   * @param files
   * @returns {Promise<void>}
   */
  onFilesChange = async file => {
    const { uploadFileDispatch } = this.props;
    //console.log("file", file);
    const { files, dataUnsaved } = this.state;
    try {
      if (!this.inValidFile) {
        const attachmentPayload = FormDataForImage(file, "file");
        //console.log("attachmentpayload", attachmentPayload);
        attachmentPayload.append("isMis", false);
        const response = await uploadFileDispatch(undefined, attachmentPayload);
        if (response) {
          const { status, message, data } = response;
          this.setState({ count: data.id });
          this.setState({ selectedImage: data.name });

          if (this.props.isEdit) {
            toast.success(
              <p className="toast-text-alignment">
                {this.props.groupData && this.props.groupData.isEdit
                  ? "File Updated Successfully"
                  : "File Updated Successfully"}
              </p>,
              successToastStyle
            );
          }

          this.setState({ extension: file[0].extension });
          //console.log(data);
          if (status) {
            //console.log("data", data, "status", status);
            //console.log("fileData ", file);
            this.setState({
              // files: [...files, { ...data, extension: file[0].extension }],
              [files]: { ...data, extension: file[0].extension },
              dataUnsaved: true
            });
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
            </p>,
            errorToastStyle
          );
        }
      }
      this.inValidFile = false;
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">{e.message}</p>,
        errorToastStyle
      );
    }
  };

  onFilesError = file => {
    if (file && file.message) {
      if (file.message.includes("too large")) {
        toast.error(
          <p className="toast-text-alignment">
            The File Exceeds The Maximum Size Limit Of 10MB
          </p>,
          errorToastStyle
        );
      } else if (file.message.includes("valid file type")) {
        toast.error(
          <p className="toast-text-alignment">Invalid File Type</p>,
          errorToastStyle
        );
      } else {
        toast.error(
          <p className="toast-text-alignment">{file.message}</p>,
          errorToastStyle
        );
      }
    }
    this.inValidFile = true;
  };
  /**
   * files upload
   * @returns {*[]}
   */
  createFileTemplate = () => {
    const { files } = this.state;
    return files.map((value, index) => {
      return (
        <div className="uploaded-file">
          <div
            className="remove-file"
            onClick={() => {
              this.removeFile(value, index);
            }}
          />
          <div className="file-detail">
            <div className="upload-icon">{value.name.split(".").pop()}</div>
          </div>
          <a
            className="best-practice-file-name"
            target="_blank"
            href={value.s3Url}
          >
            {value.name}
          </a>
        </div>
      );
    });
  };

  removeFile = async (file, index) => {
    const { removeFileDispatch } = this.props;
    const { files } = this.state;
    try {
      const response = await removeFileDispatch(undefined, {
        fid: file.id
      });
      if (response) {
        const { status, message } = response;
        if (status) {
          files.splice(index, 1);
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          this.setState({ files });
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  onMapImageFilesError = () => {
    toast.error("Invalid File Type", errorToastStyle);
    this.mapImageInvalidFile = true;
  };

  getDesignationData = async () => {
    const designationData = await getDpiitSortAction("DPIIT Officials");
    // if (designationData) {
    //   this.setState({
    //     designationOptions: designationData.data.sort(
    //       (a, b) => a.priority - b.priority
    //     ),
    //   });
    // }
    if (designationData) {
      const sortedData = designationData.data.sort(
        (a, b) => a.priority - b.priority
      );

      this.setState({
        designationOptions: [
          ...sortedData,
          {
            designationName: "Other"
          }
        ]
      });
    }
  };

  getImageType() {
    //const { selectedImage } = this.state;
    const uploadedImage = this.props.isEdit
      ? this.props.groupData.image[0].mineType
      : this.state.selectedImage;
    // Get the file extension
    if (uploadedImage) {
      const fileType = uploadedImage
        .split(".")
        .pop()
        .toLowerCase();

      switch (fileType) {
        case "jpeg":
          this.setState({ extension: "JPEG" });
          break;
        case "png":
          this.setState({ extension: "PNG" });
          break;
        case "jpg":
          this.setState({ extension: "JPG" });
          break;
        default:
          this.setState({ extension: "Unknown Image Type" });
      }
    }
  }

  handleFileChange = files => {
    const imageFile = files.find(file => file.type.startsWith("image/"));
    if (imageFile) {
      this.setState({ selectedImage: imageFile });
      const imageURL = URL.createObjectURL(imageFile);
      this.setState({ imageURL });
    }
  };

  handleRemoveImage = () => {
    if (this.state.selectedImage) {
      this.setState({
        selectedImage: null,
        extension: null,
        count: [],
        dataUnsaved: true
      });
      //this.setState({ extension: null });
      //this.setState({ count: [] });
      toast.success(
        <p className="toast-text-alignment">File Removed Successfully</p>,
        successToastStyle
      );
    }
  };

  onSubmit = async e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isApiLoading: STATUS.LOADING, searchRoles: "" });
    const {
      createPmg,
      getUsersListDispatch,
      togglePopUp,
      callApiOnSuccess
    } = this.props;
    const {
      name,
      designation,
      otherDesignation,
      email,
      mobileNumber,
      address,
      image,
      landlineNumber,
      iigAccess,
      active,
      isActive,
      imageURL,
      selectedImage,
      extension
    } = this.state;
    const postData = {
      designation,
      email,
      mobileNumber,
      name,
      landlineNumber,
      address,
      image,
      active,
      iigAccess,
      imageURL,
      selectedImage,
      extension
    };

    this.openConfirmationAlert(e);
    togglePopUp(e);

    const data = dpiitAddMemberFormAction(this.state);
    const response = await createPmg(postData);
    if (response) {
      const { status, message, data } = response;
      //console.log(response); // added
      status
        ? toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )
        : toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      status && getUsersListDispatch(undefined);
      this.openConfirmationAlert(e);
      this.setState({ isApiLoading: STATUS.SUCCESS, dataUnsaved: false });
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  onChangeSearch = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => {
      const rolesListAfterSearch = searchByValueHelper(
        prevState.rolesList,
        e,
        value,
        ["roleName"]
      );
      return {
        rolesSearch: value,
        rolesList: [...rolesListAfterSearch]
      };
    });
  };

  onSelectRole = e => {
    e.preventDefault();
    const { value } = e.target;
    this.setState(prevState => {
      let currentRole = prevState.rolesList.find(obj => obj.roleId === +value);
      currentRole.checked = !currentRole.checked;
      return {
        rolesList: [...prevState.rolesList],
        error: {
          ...prevState.error,
          rolesList: {
            error: !prevState.rolesList.filter(role => role.checked).length,
            message:
              !prevState.rolesList.filter(role => role.checked).length &&
              ERROR_MSG.DEFAULT_MSG
          }
        }
      };
    });
  };

  errors = {};

  validateForm = async e => {
    const {
      name,
      designation,
      otherDesignation,
      email,
      mobileNumber,
      landlineNumber,
      address,
      active
    } = this.state;

    let isValid = true;

    // Validate each field
    this.validateField("name", name);
    if (designation == "") {
      this.setState({
        designationError: true
      });
    }

    // Validate Other Designation if designation is "Other"
    if (designation === "Other" && otherDesignation.trim() === "") {
      //console.log('otherDesignation validation');
      this.setState({ otherDesignationError: true });
    } else {
      this.setState({ otherDesignationError: false });
    }

    this.validateField("email", email);
    // this.validatePhoneField(
    //   this.state.contactType,
    //   "contactNumber",
    //   mobileNumber
    // );
    this.validatePhoneField(
      this.state.contactType,
      "contactNumber",
      this.state.contactType == "mobile" ? mobileNumber : landlineNumber
    );
    this.validateField("address", address);

    const isNameValid = CMS_NAME_VALIDATE(name).error === false;
    //const isContacNumberValid = this.state.contactNumber.error === false;
    const isContacNumberValid = this.contactNumber.error === false;
    const isEmailValid = EMAIL_VALIDATE(email).error === false;

    //by ashish sir
    const isAddrsValid = ADDRESS_VALIDATE(address).error === false;
    const isDesignationValid = designation ? true : false;

    const isOtherDesignationValid =
      designation === "Other" ? otherDesignation.trim() !== "" : true;

    let isEmailUnique = true;
    if (isEmailValid) {
      let emailExist = await this.validateExistingEmailInfo(email);
      isEmailUnique = !emailExist.error;
    }
    // if (isEmailValid) {
    //   isEmailUnique = this.state.errors.email.error === false;
    //   this.validateExistingEmailInfo();
    // }
    let isContactInfoUnique = true;
    if (isContacNumberValid) {
      let contactInfoExist = await this.validateExistingContactInfo();
      isContactInfoUnique = !contactInfoExist.error;
    }
    // if (isContacNumberValid) {
    //   isContactInfoUnique = this.state.contactNumber.error === false;
    //   this.validateExistingContactInfo();
    // }

    // Check if any errors exist
    //const hasErrors = Object.values(this.errors).filter(item => item.error).length > 0;
    //const isFormValid = isNameValid && isEmailValid;

    const isFormValid =
      // this.props.isEdit
      //   ? isNameValid &&
      //     isEmailValid &&
      //     isContacNumberValid &&
      //     isAddrsValid &&
      //     isDesignationValid
      //   :
      isNameValid &&
      isEmailValid &&
      isContacNumberValid &&
      isAddrsValid &&
      isDesignationValid &&
      isOtherDesignationValid &&
      isEmailUnique &&
      isContactInfoUnique;
    //console.log("isEmailUnique", isEmailUnique, "isFormValid", isFormValid);
    return isFormValid;
  };

  validatePhoneField = (contactType, fieldName, value) => {
    this.contactNumber = PHONE_VALIDATE_CMS(contactType, fieldName, value);
    this.setState({
      contactNumber: this.contactNumber
    });
  };

  validateDesignationField = (fieldName, value) => {
    if (value === "" || value === undefined) {
      this.setState({
        designationError: true
      });
    }
  };

  validateField = (fieldName, value) => {
    //console.log(fieldName, value, "valid");
    switch (fieldName) {
      case "name":
        this.errors.name = CMS_NAME_VALIDATE(value);
        break;
      case "email":
        this.errors.email = EMAIL_VALIDATE(value);
        break;
      // case "contactNumber":
      //   this.contactNumber = PHONE_VALIDATE_CMS(contactType, fieldName, value);
      //   break;
      case "address":
        this.errors.address = ADDRESS_VALIDATE(value);
        break;
      default:
        break;
    }
    //console.log({ ...this.state.errors, ...this.errors }, "this.errors");
    this.setState({
      errors: { ...this.state.errors, ...this.errors }
    });
  };

  validateExistingContactInfo = async e => {
    const errorObj = {
      error: false,
      message: ""
    };
    const payloadForValidation = {
      name: "",
      designation: "",
      email: "",
      mobileNumber: this.state.mobileNumber,
      address: "",
      image: [],
      contactType: "",
      landlineNumber: this.state.landlineNumber,
      active: this.state.isActive,
      selectedContact: this.state.contactType == "mobile" ? "M" : "L"
    };
    const validatedData = await validatePMGTeamFlds(
      payloadForValidation,
      "dpiit"
    );
    //console.log(validatedData);
    if (
      validatedData &&
      validatedData.messages.length > 0 &&
      !this.props.isEdit
    ) {
      const hasMobileError = validatedData.messages.some(message =>
        message.toLowerCase().includes("mobile")
      );
      const hasLandlineError = validatedData.messages.some(message =>
        message.toLowerCase().includes("landline")
      );
      if (payloadForValidation.selectedContact === "M" && hasMobileError) {
        errorObj.error = true;
        errorObj.message = "Mobile number already exists";
      } else if (
        payloadForValidation.selectedContact === "L" &&
        hasLandlineError
      ) {
        errorObj.error = true;
        errorObj.message = "Landline number already exists";
      }
      this.setState({
        contactNumber: errorObj
      });
    }
    return errorObj;
  };

  validateExistingEmailInfo = async e => {
    //console.log("I GOT CALLED!!! YAY!!");
    const errorObj = {
      error: false,
      message: ""
    };
    const payloadForValidation = {
      name: "",
      designation: "",
      email: this.state.email,
      mobileNumber: this.state.mobileNumber,
      address: this.state.address,
      image: [],
      contactType: this.state.contactType,
      landlineNumber: this.state.landlineNumber,
      active: this.state.isActive,
      selectedContact: this.state.contactType == "mobile" ? "M" : "L"
    };
    if (payloadForValidation.email && !this.props.isEdit) {
      //console.log("Email found");
      const validatedData = await validatePMGTeamFlds(
        payloadForValidation,
        "dpiit"
      );
      //console.log("Ash Email", validatedData);
      if (validatedData && validatedData.messages.length > 0) {
        const hasEmailError = validatedData.messages.some(message =>
          message.toLowerCase().includes("email")
        );
        if (hasEmailError) {
          errorObj.error = true;
          errorObj.message = "Email already exists";
          this.errors.email = errorObj;
          this.state.errors.email = errorObj;
          let { errors } = this.state;
          errors.email = errorObj;
          this.setState({ errors });
        }
      }
    }

    return errorObj;
  };

  handleOtpModal = async e => {
    e.preventDefault();
    e.stopPropagation();
    let isValidData = await this.validateForm(e);
    //console.log(isValidData, "isValidData");
    //console.log("isValidData", isValidData);
    if (isValidData) {
      this.openConfirmationAlert(e);
    } else {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    }
  };

  handleEditConfirmation = async e => {
    e.preventDefault();
    e.stopPropagation();
    const payloadForEdit = {
      name: this.state.name,
      designation: this.state.designation,
      email: this.state.email,
      mobileNumber: this.state.mobileNumber,
      address: this.state.address,
      image: [this.state.count],
      contactType: this.state.contactType,
      landlineNumber: this.state.landlineNumber,
      active: this.state.isActive,
      selectedContact: this.state.contactType == "mobile" ? "M" : "L"
    };

    //image remove
    if (this.state.count == null || this.state.count.length == 0) {
      payloadForEdit.image = [];
    }

    if (this.state.designation === "Other") {
      payloadForEdit.designation = this.state.otherDesignation;
    }

    const responseData = await dpiitEditMemberFormAction(
      payloadForEdit,
      this.props.groupData.id
    );
    //console.log("from edit", responseData);
    return responseData;
  };

  handleAddMemberConfirmation = async e => {
    const { pmgInvestSortOrderAction1, addItemAndUpdateOrder } = this.props;
    e.preventDefault();
    e.stopPropagation();
    //console.log("this.", this.state.)
    const payloadForCreate = {
      name: this.state.name,
      designation: this.state.designation,
      email: this.state.email,
      mobileNumber: this.state.mobileNumber,
      address: this.state.address,
      image: [this.state.count],
      priority: this.state.priority,
      contactType: this.state.contactType,
      landlineNumber: this.state.landlineNumber,
      active: this.state.isActive,
      selectedContact: this.state.contactType == "mobile" ? "M" : "L"
    };
    if (this.state.designation === "Other") {
      payloadForCreate.designation = this.state.otherDesignation;
    }
    const response = await dpiitAddMemberFormAction(payloadForCreate);
    return response;
  };

  // listResponce = async () => {
  //   let listResponce = await getPmgInvestAction(this.state.isActive);

  //   if (listResponce) {
  //     console.log("listResponce", listResponce)
  //     this.setState({
  //       listResponce: listResponce.data
  //     });

  //   }
  //   //this.setState({ listResponce: listResponce });
  // }

  addItemAndUpdateOrder = newItem => {
    const { finalApiCall } = this.props;
    let pmgList = [];
    pmgList = JSON.parse(localStorage.getItem("pmgList"));
    //console.log("this.state.priority: ", this.state.priority);

    //console.log("Ashish 1",lastIndexforSelectedPriority);
    const lastItemWithPriority = pmgList
      .slice()
      .reverse()
      .find(item => {
        return item.priority === this.state.priority;
      });
    //console.log("Ashish 2", lastItemWithPriority);
    let index = pmgList.length - 1;
    if (lastItemWithPriority) {
      for (var i = 0; i < pmgList.length; i++) {
        if (pmgList[i].id == lastItemWithPriority.id) {
          index = i;
        }
      }
      //console.log("Ashish 4", index);
      pmgList.splice(index + 1, 0, newItem);
    } else {
      pmgList.push(newItem);
    }
    for (var i = 0; i < pmgList.length; i++) {
      let imageArr = [];
      pmgList[i].displayOrder = i + 1;
      imageArr.push(pmgList[i].image[0].id);
      pmgList[i].image = imageArr;
    }
    //console.log("Ashish 3", pmgList);
    return pmgList;
    //const finalList = [...pmgList]
    //let result = this.finalApiCall(pmgList);
  };
  finalApiCall = async pmgList => {
    const { pmgInvestSortOrderAction1 } = this.props;
    //console.log("from finalApiCall");
    let response = pmgInvestSortOrderAction1(pmgList).then(response => {
      //console.log("response", response);
      return response;
    });
  };

  getSecurityKey = async (e, editBoolean) => {
    //console.log("from getSecurityKey");
    e.preventDefault();
    e.stopPropagation();
    if (this.validateForm) {
      //console.log("from if");
      let { userSecurityKeyV2 } = this.props;
      const { password } = this.state;
      const notificationInfoResponse = editBoolean
        ? await this.handleEditConfirmation(e)
        : await this.handleAddMemberConfirmation(e);
      if (notificationInfoResponse) {
        const { status, message, data } = notificationInfoResponse;
        //console.log("data-----------------------:", data);
        this.setState({ showAlert: false });
        this.props.togglePopUp(e, true);
        //console.log("data----------", data);
        if (data) {
          if (Object.keys(data) && Object.keys(data).length > 0) {
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            );
            this.setState({ isActive: true });
            this.props.callApiOnSuccess(data);
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        }
      }
      try {
        //console.log("try");
        await userSecurityKeyV2(e);
        e.preventDefault();
        e.stopPropagation();
        const { securityKeyData } = this.props;
        if (get(securityKeyData, "id")) {
          let userID = get(securityKeyData, "id");
          const encrypt = new JSEncrypt();
          encrypt.setPublicKey(get(securityKeyData, "key"));
          const encryptedPassword = encrypt.encrypt(password);
          this.setState({ encryptedPassword, userID });
          this.onSubmit(e);
        } else {
          toast.error(
            <p className="toast-text-alignment">
              Please check your credentials
            </p>,
            errorToastStyle
          );
        }
      } catch (e) {
        console.log(`Error ${e.message}`);
      }
    }
  };

  openConfirmationAlert = e => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  toggleActive = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }));
  };

  handleRadioChange = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive
    }));
  };
  render() {
    const {
      isEditGroup,
      groupData,
      active,
      permission,
      isMakeUserApiLoading,
      onMakeUserActive,
      isApiLoading,
      isEdit,
      isImageUpLoading
    } = this.props;
    //console.log(this.state.contactNumber, this.state, "contactNumber");
    // const designationOptions = [
    //   { id: "1", des: "Senior Vice President" },
    //   { id: "2", des: "Vice President" },
    //   { id: "3", des: "Assistant Vice President" },
    //   { id: "4", des: "Senior Manager" },
    //   { id: "5", des: "Manager" },
    //   { id: "6", des: "Assistant Manager" },
    //   { id: "7", des: "Associate" },
    //   { id: "8", des: "Consultant" }
    // ];
    const {
      contactType,
      mobileNumber,
      landlineNumber,
      name,
      designation,
      otherDesignation,
      defaultSelected,
      email,
      address,
      errors,
      showAlert,
      isActive,
      files,
      designationOptions,
      extension
    } = this.state;

    //const designationOptions = this.getDesignationOptions();

    const isKnownDesignation = designationOptions.some(
      item => item.designationName === designation
    );

    // Fallback covers the brief moment before the sync runs
    const selectedDesignation =
      designation === "" || isKnownDesignation ? designation : "Other";

    const otherDesignationValue = otherDesignation || "";

    return (
      <React.Fragment>
        <LoaderPage loading={isImageUpLoading === STATUS.LOADING} />

        <Form
          onSubmit={e => {
            e.preventDefault();
            e.stopPropagation();
            this.handleOtpModal(e);
          }}
          noValidate
          className="signup-form"
        >
          <ConfirmationComponent
            show={showAlert}
            modalClass={"confirmation-modal"}
            saveHandler={e => {
              this.getSecurityKey(e, isEdit);
            }}
            closeHandler={e => {
              this.openConfirmationAlert(e);
            }}
            content={"Are you sure you want to do this?"}
          />
          <Form.Group controlId="name">
            <div className="d-flex justify-content-between">
              <Form.Label className="label-style">
                Name
                <span className="required">*</span>
              </Form.Label>
              {isEdit && (
                <div className="d-flex mt-2 mr-n2">
                  <p
                    className={`mb-0 mr-n3 pr-1 ${
                      this.state.isActive ? "toggle-active" : " toggle-inactive"
                    }`}
                  >
                    {this.state.isActive ? "Active" : "Inactive"}
                  </p>
                  {get(permission, "makeUserActiveInactive") ? (
                    <Form.Group
                      controlId="designation"
                      className="mb-0 ml-3 mr-2"
                    >
                      <Form.Check
                        type="checkbox"
                        label={
                          <span>
                            {isMakeUserApiLoading ? (
                              <Spinner animation="border" size="sm" />
                            ) : null}
                          </span>
                        }
                        checked={this.state.isActive}
                        onChange={() => {
                          this.setState(prevState => ({
                            isActive: !prevState.isActive,
                            dataUnsaved: true
                          }));
                        }}
                        className={`form-toggle ${
                          this.state.isActive ? "checked" : "unchecked"
                        } active-user`}
                      />
                    </Form.Group>
                  ) : null}
                </div>
              )}
            </div>
            <Form.Control
              name="name"
              type="text"
              value={name}
              //  maxLength="100"
              onPaste={this.handlefieldPaste}
              onChange={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleChange(e);
                // this.validateField("name", e.target.value);
              }}
              onBlur={() => this.validateField("name", name)}
              isInvalid={errors.name && errors.name.error}
              placeholder="Enter Name"
              //  className="field-width-cms"
              className={`${isEdit ? "field-width-cms" : "addFormText "}`}
            />

            <Form.Control.Feedback type="invalid">
              {get(errors, "name.message", null)}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="designation">
            <Form.Label className="label-style">
              Designation
              <span className="required">*</span>
            </Form.Label>
            <select
              name="designation"
              value={selectedDesignation}
              onChange={e => {
                this.handleChangeDesignation(e);
              }}
              isInvalid={this.state.designationError}
              onBlur={() =>
                this.validateDesignationField("designation", designation)
              }
              className={`best-practices-select cms-dropdown-icon cms-select ${
                isEdit ? "editFormSelect" : "addFormSelect "
              } ${designation === "" ? "placeholderColor" : ""} ${
                designation === "Other" ? "otherDesignationSelected" : ""
              }`}
              style={
                this.state.designationError ? { border: "1px solid red" } : {}
              }
            >
              <option
                value=""
                //style={{ color: "black", fontSize: "14px" }}
                // disabled={true}
              >
                -Select Designation-
              </option>
              {designationOptions.map((item, index) => (
                <option value={item.designationName} key={index}>
                  {item.designationName}
                </option>
              ))}
              {/* <option value="Other">Other</option> */}
            </select>
            {selectedDesignation === "Other" && (
              <div className="cms-other-designation-wrapper">
                <input
                  type="text"
                  name="otherDesignation"
                  value={otherDesignationValue}
                  onChange={e =>
                    this.setState({
                      otherDesignation: e.target.value,
                      otherDesignationError: false
                    })
                  }
                  //placeholder="Enter Designation"
                  className={`pmg-other-designation-input ${
                    this.state.otherDesignationError ? "input-error" : ""
                  } ${isEdit ? "field-width-cms" : "addFormText "}`}
                />
                {!otherDesignationValue && (
                  <span className="cms-other-designation-placeholder">
                    {" "}
                    Enter Designation
                    <span className="cms-other-designation-required">
                      *
                    </span>{" "}
                  </span>
                )}
              </div>
            )}
            {this.state.designationError && (
              // <p style={{ color: "red", fontWeight: "bold" }}>
              //   {this.state.designationMessage}
              // </p>
              <div className="invalidDesignation">
                {this.state.designationMessage}
              </div>
            )}
            {this.state.otherDesignationError && (
              <div className="invalidDesignation">
                {this.state.otherDesignationMessage}
              </div>
            )}
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label className="label-style"> Email </Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="email"
              type="email"
              value={email}
              onChange={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleChange(e);

                // this.validateField("email", e.target.value);
              }}
              onBlur={() => {
                this.validateField("email", email);
                this.validateExistingEmailInfo();
              }}
              isInvalid={
                // (errors.designation && errors.designation.error) ||
                // (errors.designationValid && errors.designationValid.error)
                get(errors, "email.error")
              }
              placeholder="Enter Email"
              // className="field-width-cms"
              className={`${isEdit ? "field-width-cms" : "addFormText "}`}
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "email.message") || null}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="contactType" className="mb-2">
            <Form.Label className="label-style" style={{ fontFamily: 600 }}>
              {" "}
              Contact Number
              <span className="required">*</span>
            </Form.Label>
          </Form.Group>

          <Form.Check
            inline
            type="radio"
            label="Mobile Number"
            name="contactType"
            value="mobile"
            checked={contactType === "mobile"}
            className="form-check-label1"
            // style={{
            //   fontSize: "15px",
            //   marginRight: "100px",
            //   fontFamily: "mspb"
            // }}
            // onChange={() => this.setState({ contactType: "mobile" })}
            onChange={this.onChangeMobile}
          />

          <Form.Check
            inline
            type="radio"
            label="Landline Number"
            name="contactType"
            value="landline"
            checked={contactType === "landline"}
            className="form-check-label1"
            //style={{ fontSize: "15px", fontFamily: "mspb" }}
            // onChange={() => this.setState({ contactType: "landline" })}
            onChange={this.onChangeLandline}
          />

          {contactType === "mobile" && (
            <Form.Group controlId="mobileNumber">
              <InputGroup className="mt-1">
                <InputGroup.Prepend>
                  <InputGroup.Text
                    id="inputGroupPrepend"
                    className="mobile-number"
                  >
                    +91
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  name="mobileNumber"
                  type="text"
                  maxLength="10"
                  value={mobileNumber}
                  //disabled={this.state.landlineNumber}
                  onChange={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleChange(e);
                    // if (contactType === "mobile")
                    // this.validatePhoneField(contactType, "contactNumber", e.target.value);
                    // this.validateField("mobileNumber", e.target.value);
                  }}
                  onBlur={e => {
                    this.validatePhoneField(
                      contactType,
                      "contactNumber",
                      e.target.value
                    );

                    if (!this.contactNumber.error) {
                      this.validateExistingContactInfo();
                    }
                  }}
                  isInvalid={
                    this.state.contactNumber && this.state.contactNumber.error
                  }
                  placeholder="Enter Mobile Number"
                  // className="fmobile-field-width"
                  className={`fmobile-field-width ${
                    isEdit ? "field-width-cms" : "addFormText "
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {this.state.contactNumber && this.state.contactNumber.error
                    ? this.state.contactNumber.message
                    : ""}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          )}

          {contactType === "landline" && (
            <Form.Group controlId="landlineNumber">
              <InputGroup className="mt-1">
                <Form.Control
                  name="landlineNumber"
                  type="text"
                  maxLength="13"
                  value={
                    landlineNumber
                    // this.state.landlineNumber != ""
                    //   ? landlineNumber
                    //   : groupData && groupData.landlineNumber
                  }
                  //disabled={this.state.mobileNumber}
                  onChange={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleChange(e);
                    // if (contactType === "landline")
                    //   this.validatePhoneField(contactType,"landlineNumber", e.target.value);
                  }}
                  onBlur={e => {
                    this.validatePhoneField(
                      contactType,
                      "contactNumber",
                      e.target.value
                    );

                    if (!this.contactNumber.error) {
                      this.validateExistingContactInfo();
                    }
                  }}
                  isInvalid={
                    this.state.contactNumber && this.state.contactNumber.error
                  }
                  placeholder="Enter Landline Number (xxx-xxxx-xxxx)"
                  // className="fmobile-field-width"
                  className={`fmobile-field-width ${
                    isEdit ? "field-width-cms" : "addFormText "
                  }`}
                />
                <Form.Control.Feedback type="invalid">
                  {this.state.contactNumber && this.state.contactNumber.error
                    ? this.state.contactNumber.message
                    : ""}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          )}
          <Form.Group controlId="address">
            <Form.Label className="label-style">Address</Form.Label>
            <span className="required">*</span>
            <Form.Control
              name="address"
              type="text"
              value={address}
              onPaste={this.handlefieldPaste}
              onChange={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleChange(e);

                //this.validateField("address", e.target.value);
              }}
              //All done here
              required
              isInvalid={get(errors, "address.message", null)}
              onBlur={() => this.validateField("address", address)}
              //  maxLength="50"
              placeholder="Enter Address"
              //  className="field-width-cms"
              className={`${isEdit ? "field-width-cms" : "addFormText "}`}
            />
            <Form.Control.Feedback type="invalid">
              {get(errors, "address.message", null)}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="file">
            <Form.Label className="label-style">Upload Photograph</Form.Label>

            {this.state.selectedImage ? (
              <div className="d-flex showImage">
                <div
                  className="d-flex flex-column justify-content-center align-items-center imgIcon"
                  style={{ backgroundImage: `url(${ImageBackground})` }}
                >
                  <p className="text-white text-uppercase mt-4 iconText">
                    {this.state.extension !== null ? this.state.extension : ""}
                  </p>
                </div>
                <div className="image uploadedPhoto">
                  {this.state.selectedImage.length > 20
                    ? this.state.selectedImage.split(".", 1)[0].substr(0, 20) +
                      "..."
                    : this.state.selectedImage.split(".", 1)[0]}
                </div>
                <div className="d-flex align-items-start imageUploaded">
                  <img
                    className="cancelImg"
                    src={CancleIcon}
                    alt="Cancel_Icon"
                    onClick={this.handleRemoveImage}
                  />
                </div>
              </div>
            ) : (
              <div>
                {" "}
                <Files
                  onChange={this.onFilesChange}
                  onError={this.onFilesError}
                  multiple={false}
                  accepts={IMAGE_FORMAT}
                  maxFileSize={FILE_SIZE_LIMIT.OTHER_FORMATS}
                  className="best-practices-add-files cms-add-files"
                  data-test="add-files"
                  clickable
                >
                  <div>
                    <Image
                      src={IconPlus}
                      className="addFile_plus"
                      alt="Plus Icon"
                    />
                    <div
                      className="add-file-text pt-2"
                      data-test="label-add-document"
                    >
                      Add
                    </div>
                  </div>
                </Files>
                <p className="add-file-subtext font-semibold pt-1 mb-0 font-italic-cms">
                  Supported image types: .png, .jpg, .jpeg <br />
                  Max image size: 10MB
                </p>
              </div>
            )}
          </Form.Group>
          <div style={{ paddingTop: "22px" }}>
            <Button
              className="btn-orange cms-edit-create-btn rounded mt-3 mb-3"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.handleOtpModal(e);
              }}
            >
              {isEdit ? "UPDATE" : "ADD"}
            </Button>
          </div>
        </Form>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isApiLoading: state.userManagementReducer.isApiLoading,
    isImageUpLoading: state.commonReducer.isImageUpLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadFileDispatch: uploadFileAction,
      removeFileDispatch: removeFileAction,
      dpiitAddMemberFormAction: dpiitAddMemberFormAction,
      getDpiitSortAction: getDpiitSortAction,
      dpiitEditMemberFormAction: dpiitEditMemberFormAction,
      validatePMGTeamFlds: validatePMGTeamFlds
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateDpiitForm);
